import React from "react";
import { FaFileAlt, FaDownload } from "react-icons/fa";

const LPC_Sub_Temp = () => {
  return (
    <div className="p-4 border rounded bg-light shadow-sm">
      <h5 className="mb-3 text-primary">
            <FaFileAlt className="me-2" /> Lean Project Competition (LPC) 2025
    </h5>


      <ul className="list-group list-group-flush mb-3">
        {/* Abstract Template */}
        <li className="list-group-item bg-light mt-3">
          📘 <strong>Abstract Template Overview:</strong>
          <p className="mt-2 mb-2 text-muted">
            Use the abstract template to ensure proper formatting of your LPC 2025
          </p>
          <a
            href="/ilcc2025/templates/ILCC_2025_IITTp_LPC_2025_Abstract_template.docx"
            className="btn btn-outline-secondary btn-sm"
            download
          >
            <FaDownload className="me-1" /> Download Abstract Template
          </a>

        {/* Notes */}
      <div className="mt-4">
        <p className="text-muted">
          <strong>Stage 1:</strong> Abstracts for LPC 2025 must be emailed to{" "}
          <a href="mailto:lsanthosh@nitt.edu">Dr. Santhosh Loganathan (lsanthosh@nitt.edu)</a> and keep{" "}
          <a href="mailto:Technical.Secretary1@ilce.in">Dr. Marimuthu K (Technical.Secretary1@ilce.in)</a> in CC on or before{" "}
          <strong>31st July 2025</strong>.
        </p>
      </div>

        </li>
        
        {/* Submission Guidelines */}
        <li className="list-group-item bg-light mt-3">
          📝 <strong>Submission Guidelines:</strong>
          <p className="mt-2 mb-2 text-muted">
            This document details the submission Guidelines for LPC 2025.
          </p>
          <a
            href="/ilcc2025/templates/ILCC_2025_IITTp_LPC_2025_Submission_guideline.docx"
            className="btn btn-outline-dark btn-sm"
            download
          >
            <FaDownload className="me-1" /> Download LPC Submission Guidelines
          </a>
        </li>

        {/* Flyer */}
        <li className="list-group-item bg-light mt-3">
          🧾 <strong>LPC Brochure:</strong>
          <p className="mt-2 mb-2 text-muted">
            View the LPC 2025 brochure for an overview of the competition, important dates, and contact information.
          </p>
          <a
            href="/ilcc2025/templates/ILCC_2025_IITTp_LPC 2025_Flyer.pdf"
            className="btn btn-outline-primary btn-sm"
            download
          >
            <FaDownload className="me-1" /> Download LPC Brochure
          </a>
        </li>
      </ul>
    </div>
  );
};

export default LPC_Sub_Temp;